
import React from 'react';
import SplitByDimension, { SplitByDimensionState } from './SplitByDimension';
import SplitByAllocation, { SplitByAllocationState } from './SplitByAllocation';
import { SelectOption } from '@leasequery/lq.react-component-library';
import { useAuth } from '../../../context';
import { useFeatureFlags } from '../../../context/featureFlags';
import { FeatureFlagKeys } from '../../../constants/featureFlags';
import type { ReportSettingState } from '.';
import * as Styled from './styled';

export interface SplitByAllocationSwitchState {
  splitByAllocationSwitchValue?: SelectOption<boolean>;
}

export type SplitByDimensionOrAllocationState = SplitByDimensionState & SplitByAllocationState;

interface SplitByDimensionOrAllocationProps {
  onChange: (updatedValue: SplitByDimensionOrAllocationState) => void;
  reportSettingState: ReportSettingState;
  isAllowSplitByAllocationForReport: boolean;
}

function SplitByDimensionOrAllocation({
  onChange,
  reportSettingState,
  isAllowSplitByAllocationForReport,
}: Readonly<SplitByDimensionOrAllocationProps>): JSX.Element | null {
  const { clientSetting } = useAuth();
  const { isAllowSplitByAllocationForClient, isCoaEnabled } = clientSetting || {};
  const splitState: SplitByDimensionOrAllocationState = reportSettingState;

  const { isFeatureEnabled } = useFeatureFlags();
  const isSplitByAllocationEnabled = isFeatureEnabled(FeatureFlagKeys.ReportSplitByAllocation);

  if (!isSplitByAllocationEnabled || !isAllowSplitByAllocationForClient || !isAllowSplitByAllocationForReport) {
    return null;
  }

  return (
    <Styled.TopBorder>
      {isCoaEnabled ? (
        <SplitByDimension splitState={splitState} onChange={onChange} />
      ) : (
        <SplitByAllocation splitState={splitState} onChange={onChange} />
      )}
    </Styled.TopBorder>
  );
}

export default SplitByDimensionOrAllocation;
